// extracted by mini-css-extract-plugin
export default {"block":"NotBlock_block__sRhun","void":"NotBlock_void__frDJ7"};